/**
 * @function
 * @name debounce
 * @param {function} func
 * @param {number} delay
 */

export const debounce = (func, delay) => {
  let timerId;

  if (timerId) clearTimeout(timerId);
  timerId = setTimeout(() => func(), delay);
};
